<template>
  <header id="site-header">
    <div class="inner" :class="{'spActive': trg}">
      <figure class="logo">
        <a href="/">
          <img src="/images/common/logo.webp" alt="logo" />
        </a>
      </figure>

      <div class="trg" @click="trg = !trg">
        <svg v-if="!trg" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="M160-269.23v-40h640v40H160ZM160-460v-40h640v40H160Zm0-190.77v-40h640v40H160Z"/></svg>
        <svg v-else class="lg" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e8eaed"><path d="M256-227.69 227.69-256l224-224-224-224L256-732.31l224 224 224-224L732.31-704l-224 224 224 224L704-227.69l-224-224-224 224Z"/></svg>
      </div>

      <transition name="fade">
        <div class="gnavi" v-show="trg">
          <nav role="navigation" itemscope="itemscope" itemtype="http://scheme.org/SiteNavigationElement">
            <ul>
              <li itemprop="name" class="tabnone"><a itemprop="url" href="/">トップページ</a></li>
              <li itemprop="name"><a itemprop="url" href="/about/">会社概要<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor"><path d="m531.69-480-184-184L376-692.31 588.31-480 376-267.69 347.69-296l184-184Z"></path></svg></a></li>
              <li itemprop="name"><a itemprop="url" href="/business/">事業実績<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor"><path d="m531.69-480-184-184L376-692.31 588.31-480 376-267.69 347.69-296l184-184Z"></path></svg></a></li>
              <li itemprop="name"><a itemprop="url" href="/news/">新着情報<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor"><path d="m531.69-480-184-184L376-692.31 588.31-480 376-267.69 347.69-296l184-184Z"></path></svg></a></li>
            </ul>
          </nav>
        </div>
      </transition>
      <a href="/contact/" class="btn">お問い合わせ</a>
    </div>

    <transition name="fade">
      <div v-if="trg" class="overlay"></div>
    </transition>

  </header>
</template>

<style lang="scss" scoped>
header{
  width: 95%;
  top: 0;
  left: 2.5%;
  position: fixed;
  padding: 0 1.6rem;
  z-index: 1000;
  @media screen and (max-width: module.$tab){
    width: 96%;
    left: 2%;
  }
  @media screen and (max-width: module.$phone){
    left: 0;
    width: 100%;
    padding: 0 module.side();
    .overlay{
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(module.$normal, .8);
      z-index: -2;
    }
  }
  &:before{
    content: '';
    width: 100%;
    height: 0;
    background: module.$white;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    transition: all 400ms module.$ease;
    transition-duration: height, border-radius, box-shadow;
  }
  &.active{
    &:before{
      height: 100%;
      border-radius: 0 0 .8rem .8rem;
      box-shadow: 0 0 3.2rem rgba(module.$normal,.12);
      @media screen and (max-width: module.$phone){
        border-radius: 0;
      }
    }
  }
  .inner{
    display: grid;
    grid-template-columns: auto auto;
    padding: .92rem 0;
    @media screen and (max-width: module.$phone){
      padding: .8rem 0;
      &.spActive{
        &:after{
          opacity: 1;
        }
      }
      &:after{
        content: '';
        width: 100%;
        height: 100%;
        background: module.$white;
        position: absolute;
        top: 0;
        left: 0;
        z-index: -1;
        opacity: 0;
        transition: opacity 400ms module.$ease;
      }
    }
    > *{
      align-self: center;
    }
  }
  .logo{
    width: 14rem;
    justify-self: flex-start;
    transform: translateY(-.32rem);
    @media screen and (max-width: module.$phone){
      width: 12rem;
    }
    img{
      width: 100%;
    }
  }
  .trg{
    display: none;
    @media screen and (max-width: module.$phone){
      width: 3.6rem;
      height: 3.6rem;
      display: block;
      position: fixed;
      border-radius: 1rem;
      top: .8rem;
      right: 1rem;
      @include module.flex();
      align-items: center;
      justify-content: center;
      cursor: pointer;
      background: module.$main;
      svg{
        width: 50%;
        display: block;
        fill: module.$white;
        &.lg{
          transform: scale(1.2);
        }
      }
    }
  }
  .gnavi{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    @media screen and (min-width: calc(#{module.$phone} + 1px)){
      display: block !important;
    }
    @media screen and (max-width: module.$phone){
      background: module.$white;
      top: calc(var(--head) - 1px);
      left: 0;
      transform: translate(0);
      width: 100%;
    }
    ul{
      @include module.flex();
      justify-content: center;
      align-items: center;
      @media screen and (max-width: module.$phone){
        display: block;
        border-top: module.$border 1px solid;
      }
      li{
        margin: 0 0 0 3.2rem;
        font-weight: 500;
        @media screen and (max-width: module.$phone){
          margin: 0;
          border-bottom: module.$border 1px solid;
          &:last-child{
            border: none;
          }
        }
        &.tabnone{
          @media screen and (max-width: module.$tab){
            display: none;
            + li{
              margin: 0;
            }
          }
        }
        a{
          position: relative;
          transition: color 240ms module.$ease;
          @media screen and (max-width: module.$phone){
            padding: module.side();
            display: block;
          }
          svg{
            display: none;
            @media screen and (max-width: module.$phone){
              position: absolute;
              top: 50%;
              right: module.side();
              transform: translateY(-50%);
              width: 1.6rem;
              display: block;
              opacity: .4;
            }
          }
          &:before{
            content: '';
            width: 0;
            height: 2px;
            background: module.$main;
            position: absolute;
            left: 50%;
            bottom: -.32rem;
            transform: translateX(-50%);
            transition: width 200ms module.$ease;
          }
          &:hover{
            color: module.$main;
            &:before{
              width: 100%;
            }
          }
        }
        &:first-child{
          margin: 0;
        }
      }
    }
  }
  .btn{
    justify-self: flex-end;
    @include module.btn(module.$white, module.$main);
    @media screen and (max-width: module.$phone){
      display: none;
    }
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s module.$ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>

<script>
export default {
  data: function(){
    return {
      trg: false
    }
  },
}
</script>